// components/PasswordVerificationTray.tsx
import React from 'react'
import { Tray } from '@mobi/component-library/Overlays/Tray'
import { PasswordVerification } from './PasswordVerification'

interface Props {
  isOpen: boolean
  onVerify: () => void
  onCancel: () => void
  accountNumber: number
}

export const PasswordVerificationTray: React.FC<Props> = ({
  isOpen,
  onVerify,
  onCancel,
  accountNumber,
}) => (
  <Tray isOpen={isOpen} headerTitle='Verify Account' onDismiss={onCancel}>
    <PasswordVerification onVerify={onVerify} onCancel={onCancel} accountNumber={accountNumber} />
  </Tray>
)
